import React, { Component } from "react";
import Cookies from "js-cookie";
import PerfectScrollbar from "react-perfect-scrollbar";
import mixpanel from "mixpanel-browser";
import { isEqual, cloneDeep, get } from "lodash";
import { connect } from "react-redux";

import { MIXPANEL_VIDEOS_PAGE } from "../../mixpanel/mixpanel_constants";
import { _nullParams as initialVideoParams } from "./VideoReducers";
import {
  fetchDropboxVideo,
  updateParams,
  fetchTranscript,
  downloadAllTranscript,
  updateVideoDetailBreadcrumb,
  updateVideoPageState,
} from "./VideoActions";
import { deleteValue } from "../../utilities";
import { fetchNotes } from "../../Shared/Notes/NoteActions";
import { receiveServerErrors } from "../../Shared/Errors/errorActions";
import Filters from "../../Shared/filters";
import TranscriptIndex from "./Components/TranscriptIndex";
import SinglePublish from "./Components/SinglePublish";
import initialSingleVideo from "./Components/initialSingleVideo";
import Ranking from "./Components/RankingModal";
import IndexFilterToggle from "../Components/IndexFilterToggle";
import IndexPageGrid from "../Components/IndexPageGrid";

const brand_id = Cookies.get("bId");
const user_id = Cookies.get("uId");
const { REACT_APP_BASE_URL } = process.env;

// ** Styles
import "./Components/video.scss";

import IndexPagination from "../../Shared/IndexPagination";
import Loader from "../../Shared/Loader";
import HorizontalFilters from "../../Shared/HorizontalFilters/HorizontalFilters";
import SinglePublishMessage from "./Components/SinglePublishMessage";

const sortOptions = [
  // { value: "youtube_published_at", name: "Recently Added" },
  { value: "created_at", name: "Recently Added" },
  { value: "likes", name: "Number of Likes" },
  { value: "youtube_view_count", name: "Number of Views" },
  { value: "comment_count", name: "Number of Comments" },
  { value: "positive_sent_MLB", name: "Positive Sentiment - Vyrill Data" },
  { value: "negative_sent_MLB", name: "Negative Sentiment - Vyrill Data" },
  { value: "video_popularity", name: "Popularity - Vyrill Data" },
  { value: "gpt_sentiment_score", name: "Highest Sentiment Score" },
];

const VIDEOS_TABS = ["My Videos", "Competition"];
const WIDGET_TABS = ["brand", "fan", "all"];

class VideoIndexContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersOpen: false,
      search: get(props, "params.search", ""),
      addYouTubeVideoUrl: false,
      annotateOpen: false,
      openMultiPublish: false,
      singleVideo: initialSingleVideo,
    };
    props.getNotes("video");
  }

  componentDidMount() {
    const { getReceiveServerErrors, getDropboxVideo, location, history } =
      this.props;
    const { search } = location || {};
    const queryParams = new URLSearchParams(search);
    const error = queryParams.get("error");
    const dropboxVideoId = queryParams.get("dropboxVideoId");

    if (error) {
      getReceiveServerErrors({
        statusText:
          error === "1"
            ? "Please enter a video URL which is already connected to your Dropbox account."
            : "",
      });
      queryParams.delete("error");
      history.replace({ search: queryParams.toString() });
    }

    if (dropboxVideoId) {
      getDropboxVideo(dropboxVideoId);
      this.openAnnotation();
      queryParams.delete("dropboxVideoId");
      history.replace({ search: queryParams.toString() });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      getNotes,
      currentBrand,
      location,
      getUpdateParams,
      videos,
      getTranscript,
      transcriptView,
      toggleTranscript,
      downloadTranscript,
      videoReportedAsFlagged,
      flagSelectAll,
      favSelectAll,
      publishSelectAll,
      publishVideosCheckList,
      flaggedVideosCheckList,
      favVideosCheckList,
      successfullyUnFlagged,
    } = this.props;
    const { currentBrand: prevCurrentBrand } = prevProps;

    if (videoReportedAsFlagged !== prevProps.videoReportedAsFlagged) {
      if (!videoReportedAsFlagged) {
        // OnFlagged closed Refetching videos
        getUpdateParams({ reFetch: true });
      }
    }

    if (successfullyUnFlagged !== prevProps.successfullyUnFlagged) {
      if (!successfullyUnFlagged) {
        // OnFlagged closed Refetching videos
        getUpdateParams({ reFetch: true });
      }
    }

    if (flagSelectAll !== prevProps.flagSelectAll) {
      const results = [];
      videos.forEach((e) => {
        results.push(e.video._id);
      });
      this.props.updatePageState({ flaggedVideosCheckList: results });
    }

    if (favSelectAll !== prevProps.favSelectAll) {
      const results = [];
      videos.forEach((e) => {
        results.push(e.video._id);
      });
      this.props.updatePageState({ favVideosCheckList: results });
    }
    
    // if (publishSelectAll !== prevProps.publishSelectAll) {
    //   const results = [];
    //   if (publishSelectAll) {
    //     videos?.forEach((e) => {
    //       results.push(e.video._id);
    //     });
    //   }
    //   this.props.updatePageState({ publishVideosCheckList: results });
    // }

    if (publishSelectAll !== prevProps.publishSelectAll) {
      const results = [];
      const allPublished = videos.every(
        (e) => e.video?.additional_data?.data?.published_to_swirl ===
          "Successfully updated published status"
      );
      if (publishSelectAll) {
        videos?.forEach((e) => {
          if (
            e.video?.additional_data?.data?.published_to_swirl !==
            "Successfully updated published status" ||
            allPublished
          ) {
            results.push(e.video._id);
          }
        });
      }
      this.props.updatePageState({ publishVideosCheckList: results });
    }

    if (
      flaggedVideosCheckList.length !== prevProps.flaggedVideosCheckList.length
    ) {
      this.props.updatePageState({ flagSelectAll: false });
    }

    if (favVideosCheckList.length !== prevProps.favVideosCheckList.length) {
      this.props.updatePageState({ favSelectAll: false });
    }

    if (
      publishVideosCheckList?.length !==
      prevProps?.publishVideosCheckList?.length
    ) {
      this.props.updatePageState({ publishSelectAll: false });
    }

    const { pathname } = location || {};
    const isWidget = pathname === "/widget";
    if (currentBrand) {
      if (currentBrand._id !== prevCurrentBrand._id) {
        getUpdateParams({
          tab: "My Videos",
          is_widget: false,
          ...(isWidget && { is_widget: true, tab: "brand" }),
        });
        getNotes("video");
      }
    }

    if (transcriptView && toggleTranscript !== prevProps.toggleTranscript) {
      if (toggleTranscript) {
        getTranscript(videos.map((k) => k.video._id));
      }
    }

    if (downloadTranscript !== prevProps.downloadTranscript) {
      const { downloadState, fileType } = downloadTranscript;
      if (downloadState) {
        this.downloadAllTranscripts(fileType);
      }
    }
  }

  downloadAllTranscripts = (fileType) => {
    const { params, keywordsOnly, transcriptView } = this.props;
    const { search, filters, tab } = params;
    const withSearch = {
      highlight: search,
      report_type: keywordsOnly ? "keywords_only" : "all_transcripts",
      filters,
      tab,
      brand_id,
      user_id,
    };
    const withoutSearch = {
      filters,
      tab,
      brand_id,
      user_id,
    };
    const headers = { "Content-Type": "application/json" };
    const config = {
      method: "POST",
      body: JSON.stringify(transcriptView ? withSearch : withoutSearch),
      headers,
    };

    fetch(
      `${REACT_APP_BASE_URL}/jwt_api/videos/download_all_transcript_report.${fileType}`,
      config
    )
      .then((response) => response.blob())
      .then((blob) => URL.createObjectURL(blob))
      .then((url) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = `all-transcript-report.${fileType}`;
        link.setAttribute("type", "hidden");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // For Firefox it is necessary to delay revoking the ObjectURL
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 100);
        this.props.allTranscriptPDF({
          downloadState: false,
          loadingTranscriptPdf: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  toggleFilters = () => {
    this.setState({ filtersOpen: !this.state.filtersOpen });
  };

  updateParams = (params) => () => {
    this.props.getUpdateParams(params);
  };

  updateTab = (params) => () => {
    if (params.tab != this.props.params.tab) {
      if (params.tab === "My Videos") {
        mixpanel.track(MIXPANEL_VIDEOS_PAGE.MY_VIDEOS_TAB);
      }

      if (params.tab === "Competition") {
        mixpanel.track(MIXPANEL_VIDEOS_PAGE.COMPETITORS_TAB);
      }
    }

    this.props.getUpdateParams(params);
  };

  handleChangeParentTopics = ({ target }) => {
    const { getUpdateParams, params, filters } = this.props;
    const {
      filters: { topic },
    } = params || {};
    const { topics, subTopics } = topic || {};
    const payload = {
      topics: [...topics],
      subTopics: [...subTopics],
    };
    const { checked, value } = target;
    const childrenTopics = filters.topic[value];
    if (checked) {
      payload.topics.push(value);
      payload.subTopics = [...payload.subTopics, ...childrenTopics];
    } else {
      payload.topics = payload.topics.filter((topic) => topic !== value);
      payload.subTopics = payload.subTopics.filter(
        (subTopic) => !childrenTopics.includes(subTopic)
      );
    }
    getUpdateParams({
      ...params,
      filters: { ...params.filters, topic: payload },
      page: 1,
    });
  };

  handleChangeSubTopics = (key, value, checked) => {
    const { getUpdateParams, params } = this.props;
    const {
      filters: { topic },
    } = params || {};
    const { topics, subTopics } = topic || {};
    const payload = {
      topics: [...topics],
      subTopics: [...subTopics],
    };
    if (checked) {
      payload.subTopics.push(value);
    } else {
      payload.subTopics = payload.subTopics.filter(
        (subTopic) => subTopic !== value
      );
    }
    getUpdateParams({
      ...params,
      filters: { ...params.filters, topic: payload },
      page: 1,
    });
  };

  updateFilters =
    (key) =>
    ({ target }) => {
      const { getUpdateParams, params } = this.props;
      const { checked, value, id } = target;
      const allfilters = cloneDeep(params.filters);
      if (checked) {
        mixpanel.track(MIXPANEL_VIDEOS_PAGE.SELECT_FILTER, {
          selected_filter: `${key} - ${target.value}`,
        });
      }
      if (key === "topic") {
        this.handleChangeSubTopics(key, value, checked);
      } else {
        if (params.filters[key].radio) {
          const v = isNaN(value) ? value : parseInt(value, 10);
          allfilters[key].value = checked ? v : null;
        } else if (checked) {
          allfilters[key].push(value);
        } else {
          if (value === "Campaign") {
            const filterData = allfilters[key]?.filter(
              (str) => !str.includes("Campaign-")
            );
            allfilters[key] = filterData;
            deleteValue(allfilters[key], value);
          } else {
            deleteValue(allfilters[key], value);
          }
        }
        getUpdateParams({ filters: allfilters, page: 1 });
      }
    };

  updateSubFilters =
    (key) =>
    (subKey) =>
    ({ target }) => {
      const { params, getUpdateParams } = this.props;
      const { checked, value } = target;
      const filters = cloneDeep(params.filters);
      const filterValues = filters[key][subKey] || [];
      if (checked) {
        mixpanel.track(MIXPANEL_VIDEOS_PAGE.SELECT_FILTER, {
          selected_filter: `${key} - ${subKey} - ${target.value}`,
        });
      }
      checked ? filterValues.push(value) : deleteValue(filterValues, value);
      filters[key][subKey] = filterValues;
      getUpdateParams({ filters, page: 1 });
    };

  updateSort = ({ target }) => {
    this.props.getUpdateParams({ sort: target.value, page: 1 });
  };

  updateDates = ({ startDate, endDate }) => {
    const dates = {};
    dates.startDate = startDate ? startDate.format() : null;
    dates.endDate = endDate ? endDate.format() : null;
    this.props.getUpdateParams({ dates, page: 1 });
  };

  updateTrending = ({ target }) => {
    this.props.getUpdateParams({ trending: target.checked, page: 1 });
  };

  dismissFilter =
    (key, value, subKey = false) =>
    () => {
      const { params, getUpdateParams } = this.props;
      const filters = cloneDeep(params.filters);
      if (filters[key].radio) {
        filters[key].value = null;
      } else if (subKey) {
        deleteValue(filters[key][subKey], value);
      } else {
        deleteValue(filters[key], value);
      }
      getUpdateParams({ filters, page: 1 });
    };

  setModal = (node) => (this.modal = node);

  openAnnotation = () => {
    this.setState({ annotateOpen: true });
  };

  handleDownloadAllTranscripts = () => {
    mixpanel.track(MIXPANEL_VIDEOS_PAGE.DOWNLOAD_ALL_TRANSCRIPTS);
  };

  // handleOpenMultiPublish = () => {
  //   mixpanel.track(MIXPANEL_VIDEOS_PAGE.PUBLISH_TO_APP);
  //   this.setState({ openMultiPublish: true });
  // };

  // handleCloseMultiPublish = () => {
  //   this.setState({ openMultiPublish: false });
  // };

  handleOpenSinglePublish = (id) => () => {
    const { videos } = this.props;
    const singleVideo =
      videos && videos.length && videos.find(({ video }) => video._id === id);
    this.setState({
      singleVideo: singleVideo || initialSingleVideo,
    });
    this.props.updatePageState({ openSinglePublish: true });
  };

  handleCloseSinglePublish = () => {
    this.setState({
      singleVideo: initialSingleVideo,
    });
    this.props.updatePageState({ openSinglePublish: false });
  };

  handleVideoCard = (video) => () => {
    video = video || {};
    const { params, updateVideoDetailBreadcrumb } = this.props;
    const isAppManager = location?.hash?.includes("/published");
    const videosPageBreadcrumb = [
      {
        name: "Videos",
        type: "link",
        link: "/videos",
        page: "videos",
      },
      {
        name: params.isFavoriteTab
          ? "Favorites Videos"
          : params.isFlaggedTab
          ? "Flagged Videos"
          : params.isTrashTab
          ? "Trash Videos"
          : params.tab === "Competition"
          ? "Competitors"
          : params.isCampaignTab
          ? "Campaign Videos"
          : params.tab,
        tab: params.tab,
        type: "tab",
        link: "/videos",
        page: "videos",
      },
    ];

    const appManagerPageBreadcrumb = [
      {
        name: "Published",
        type: "link",
        link: "/published",
        page: "published",
      },
      {
        name: params.tab === "fan" ? "Shopper" : "Brand",
        tab: params.tab,
        type: "tab",
        link: "/published",
        page: "published",
      },
    ];
    updateVideoDetailBreadcrumb(
      isAppManager ? appManagerPageBreadcrumb : videosPageBreadcrumb
    );
    mixpanel.track(MIXPANEL_VIDEOS_PAGE.CLICK_VIDEO_CARD, {
      video_id: video._id,
      sponsored: video.sponsored,
      topics: video.topics,
      sub_topics: video.sub_topics,
      published_at_on_platform: video.published_at_on_platform,
    });
  };

  render() {
    const {
      videos,
      transcripts,
      totalPages,
      loading,
      params,
      count,
      filters,
      notes,
      transcriptView,
      roles,
      pro,
      toggleTranscript,
      keywordsOnly,
      location,
      currentUser,
    } = this.props;

    const { pathname } = location || {};
    const isWidget = pathname === "/widget";
    if (isWidget) {
      tabs = WIDGET_TABS;
    }
    let { page, tab, sort, desc, dates, trending, search } = params;
    const { filtersOpen, openSinglePublish, singleVideo } = this.state;
    // const topicFilters = filters ? Object.keys(filters?.topic) : [];
    if (
      roles.includes("vip_brand_manager") ||
      roles.includes("vip_influencer")
    ) {
      tabs = ["Videos"];
      tab = "Videos";
    }
    const basic = roles.includes("vip_brand_manager") && !pro;

    return (
      <>
        <HorizontalFilters
          filters={params.filters}
          dismissFilter={this.dismissFilter}
        />
        <div className={`index-content ${filtersOpen && "content-left"}`}>
          <div className="content-body campaign-body">
            <IndexFilterToggle
              filtersOpen={filtersOpen}
              toggleFilters={this.toggleFilters}
            />
            {!transcriptView && (
              <IndexPageGrid
                loading={loading}
                items={videos}
                notes={notes}
                currentBrand={this.props.currentBrand}
                currentUser={currentUser}
                tab={tab}
                cardType="Video"
                handleOpenSinglePublish={this.handleOpenSinglePublish}
                handleVideoCard={this.handleVideoCard}
              />
            )}
            <PerfectScrollbar
              className="main-menu-content"
              options={{ wheelPropagation: true }}
              style={{
                maxHeight: "75vh",
                minScrollbarLength: 5,
                paddingRight: "15px",
                paddingLeft: "28px",
              }}
            >
              {transcriptView && (
                <>
                  {loading ? (
                    <Loader />
                  ) : (
                    <TranscriptIndex
                      videos={videos}
                      transcript={transcripts}
                      loading={loading}
                      search={search}
                      notes={notes}
                      toggleTranscript={toggleTranscript}
                      keywordsOnly={keywordsOnly}
                      totalVideo={loading ? null : count}
                      toggleFilters={this.toggleFilters}
                      filtersOpen={filtersOpen}
                    />
                  )}
                </>
              )}
              {!transcriptView && (
                <>
                  <SinglePublish
                    singleVideo={singleVideo}
                    // open={openSinglePublish}
                    onClose={this.handleCloseSinglePublish}
                    pathname="videos"
                  />
                  <Ranking
                    open={
                      !isEqual(
                        this.props.params.filters,
                        initialVideoParams.filters
                      ) && loading
                    }
                  />
                </>
              )}
              <SinglePublishMessage
                singleVideo={singleVideo}
                onClose={this.handleCloseSinglePublish}
              />
            </PerfectScrollbar>
          </div>
          <div className="mt-2">
            {!loading && totalPages > 1 && (
              <IndexPagination
                page={page}
                totalPages={totalPages}
                update={(param) => this.updateParams(param)()}
                cardType="Video"
              />
            )}
          </div>
        </div>
        {filtersOpen && (
          <Filters
            filters={filters}
            sort={sort}
            desc={desc}
            sortOptions={sortOptions}
            dates={dates}
            trending={trending}
            defaultFilter="topic"
            selectedFilters={params.filters}
            updateFilters={this.updateFilters}
            updateSort={this.updateSort}
            updateParams={this.updateParams}
            updateSubFilters={this.updateSubFilters}
            updateParentTopics={this.handleChangeParentTopics}
            toggleFilters={this.toggleFilters}
            updateDates={this.updateDates}
            updateTrending={this.updateTrending}
            loading={loading}
            basic={basic}
            topicFilters={[]}
            page="videos"
            filtersHeight="65vh"
            indexRedesign
          />
        )}
      </>
    );
  }
}

VideoIndexContainer.defaultProps = { tabs: VIDEOS_TABS };

const mapStateToProps = ({
  videos,
  transcript,
  toggleTranscript,
  downloadTranscript,
  keywordsOnly,
  videoParams,
  videoData,
  videoNotes,
  navbarStatsReducer,
  videoPageStates,
}) => ({
  videos,
  transcripts: (transcript && transcript.transcripts) || [],
  toggleTranscript,
  downloadTranscript,
  keywordsOnly,
  params: videoParams,
  loadedFor: videoData && videoData.loaded_for ? videoData.loaded_for : "",
  totalPages: videoData && videoData.totalPages,
  loading: videoData && videoData.loading,
  count: videoData && videoData.count,
  filters: videoData && videoData.filters,
  transcriptView: videoData && videoData.transcriptView,
  notes: videoNotes,
  currentBrand: navbarStatsReducer.currentBrand,
  roles: navbarStatsReducer.roles,
  pro: navbarStatsReducer.current_user.is_subscribed_to_vip,
  currentUser: navbarStatsReducer.current_user,
  videoReportedAsFlagged: videoPageStates.videoReportedAsFlagged,
  flaggedVideosCheckList: videoPageStates.flaggedVideosCheckList,
  favVideosCheckList: videoPageStates.favVideosCheckList,
  successfullyUnFlagged: videoPageStates.successfullyUnFlagged,
  flagSelectAll: videoPageStates.flagSelectAll,
  favSelectAll: videoPageStates.favSelectAll,
  publishSelectAll: videoPageStates.publishSelectAll,
});

const mapDispatchToProps = (dispatch) => ({
  getNotes: () => dispatch(fetchNotes("video")),
  getReceiveServerErrors: (errorProps) =>
    dispatch(receiveServerErrors(errorProps)),
  getDropboxVideo: (dropboxVideoId) =>
    dispatch(fetchDropboxVideo(dropboxVideoId)),
  getUpdateParams: (params) => dispatch(updateParams(params)),
  getTranscript: (video_ids) => dispatch(fetchTranscript(video_ids)),
  updateVideoDetailBreadcrumb: (data) =>
    dispatch(updateVideoDetailBreadcrumb(data)),
  allTranscriptPDF: ({ downloadState, loadingTranscriptPdf }) =>
    dispatch(
      downloadAllTranscript({
        downloadState,
        loadingTranscriptPdf,
        fileType: "pdf",
      })
    ),
  updatePageState: (flaggedVideosCheckList) =>
    dispatch(updateVideoPageState(flaggedVideosCheckList)),

  updatePageState: (openSinglePublish) =>
    dispatch(updateVideoPageState(openSinglePublish)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VideoIndexContainer);
